import SubCategoryForm from './AddSubCategoryFormContainer';

export default SubCategoryForm;